import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { navigate } from '@client/routes';

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type Tab = {
  label: string;
  link: string;
  id: number;
};

type LinkedTabsProps = {
  tabs: Tab[];
  activeTab: number;
  children: React.ReactNode;
  onClick?: () => void;
};
export default function LinkedTabs({
  tabs,
  activeTab,
  children,
  onClick,
}: LinkedTabsProps) {
  const handleClick = (tab: Tab) => {
    onClick && onClick();
    navigate(tab.link);
  };
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab}>
          {tabs.map((tab, index) => {
            return (
              <Tab
                key={index}
                label={tab.label}
                {...a11yProps(tab.id)}
                onClick={() => handleClick(tab)}
              />
            );
          })}
        </Tabs>
      </Box>
      <Box>
        <Typography>{children}</Typography>
      </Box>
    </Box>
  );
}
